module.exports = __webpack_public_path__ + "img/glass-panel.e281f4d.svg";